// @ts-nocheck
import vuexStore from '@/vuex-store';
import { mapControl } from '@/constants';
import DropMarkerCollection from '@/lib/map-control/collection/DropMarkerCollection';
import StoreMarkerCollection from '@/lib/map-control/collection/StoreMarkerCollection';
import WorkerMarkerCollection from '@/lib/map-control/collection/WorkerMarkerCollection';
import Bounds from './Bounds';
export class MapMarkerList {
    drops;
    stores;
    workers;
    bounds;
    mapInstance;
    mapControlState = vuexStore.state.mapControl;
    mapControl = mapControl;
    setOptions(naver, hubControlMap) {
        this.bounds = Bounds.getInstance();
        this.hubControlMap = hubControlMap;
        this.mapInstance = hubControlMap.mapInstance;
        this.drops = new DropMarkerCollection(naver, hubControlMap);
        this.stores = new StoreMarkerCollection(naver, hubControlMap);
        this.workers = new WorkerMarkerCollection(naver, hubControlMap);
    }
    getStoreMarker(storeId) {
        return this.stores.getMarker(storeId);
    }
    getDropMarker(orderId) {
        return this.drops.getMarker(orderId);
    }
    addDropMarker(payload) {
        return this.drops.addMarker(payload);
    }
    addStoreMarker(...payload) {
        return this.stores.addMarker(...payload);
    }
    addWorkerMarker(payload) {
        return this.workers.addMarker(payload);
    }
    /**
     * 워커 마커 리스트 추가
     * @param {Object} workers
     */
    addWorkerMarkers(workers) {
        Object.values(workers).forEach((workerData) => {
            this.addWorkerMarker(workerData);
        });
    }
    /**
     * 스토어 마커 추가
     * @param storeList 스토어 데이터 해시맵
     */
    addStoreMarkers(storeList) {
        Object.values(storeList).forEach((storeData) => {
            this.addStoreMarker(storeData, this.drops);
        });
    }
    /**
     * 주문 마커 가중치 업데이트
     * 주문과 연관된 상점, 라이더를 순회하며 본인 가중치를 최신화 시킨다.
     * @param orderId 주문 아이디
     * @param isDecrease 감소 여부
     * @param ignoreWorker 라이더는 가중치 무시 (상점 선택 상태에서는 라이더 가중치 무시해야 함)
     * @returns
     */
    updateOrderMarkerWeight(orderId, isDecrease = false, ignoreWorker = false) {
        const order = this.mapControlState.orderList[orderId];
        if (!order) {
            console.log('[updateOrderMarkerWeight] 주문이 없습니다.', orderId);
            return;
        }
        const { storeId, allocatedWorkerCode, isAccepted, workerCode: _workerCode, } = order;
        const workerCode = allocatedWorkerCode || _workerCode;
        const targetMarker = {
            stores: storeId,
            drops: orderId,
        };
        // 접수가 아닐 때만 라이더 가중치 추가
        if (!isAccepted && !ignoreWorker) {
            targetMarker.workers = workerCode;
        }
        Object.entries(targetMarker).forEach(([markerType, id,]) => {
            const marker = this?.[markerType].getMarker(id);
            if (marker) {
                marker.updateRelatedWeight(isDecrease);
            }
        });
        console.log('--- 가중치 로직 END ---');
    }
}
export default new MapMarkerList();
